import axios from '../axios';
import { G } from '../querystring';
import { Debounce } from '../util';

export declare interface PromotionalCode {
    promotionalCodeID: string;
    name: string;
    description: string;
    code: string;
    sameOwner: boolean;
}

declare interface getPromoResp {
    promotionalCode: PromotionalCode;
}

export function GetPromotionalCode(code: string, email?: string): Promise<PromotionalCode> {
    return axios.get<getPromoResp>(`/promos/${encodeURIComponent(code)}`, {
        params: {
            'email': email,
        },
    }).then(resp => resp.data.promotionalCode);
}

interface inputOpts {
    $email?: HTMLInputElement;
    success?: (p: PromotionalCode) => void;
    error?: () => void;
}

export class Input {
    $input: HTMLInputElement;
    Opts?: inputOpts;

    Dirty: boolean = false;

    constructor($input: HTMLInputElement, opts?: inputOpts) {
        this.$input = $input;
        this.Opts = opts;

        const debounce = Debounce(() => this.Check(), 1000, false);

        const makeDirty = () => {
            this.Dirty = true;
            debounce();
        };

        $input.addEventListener('input', makeDirty);

        opts?.$email?.addEventListener('input', makeDirty);

        const queryPromo = G().Get('promo');
        if (queryPromo) {
            $input.value = queryPromo;
            void this.Check();
        }
    }

    public async Check() {
        if (!this.Dirty) {
            return;
        }

        if (!this.$input.value.trim()) {
            this.$input.setCustomValidity('');
            this.Opts?.error?.();
            this.Dirty = false;
            return;
        }

        let p;

        try {
            p = await GetPromotionalCode(this.$input.value.trim(), this.Opts?.$email?.value);
        } catch {
            // ignore
        }

        if (p?.promotionalCodeID) {
            if (p?.sameOwner) {
                this.$input.setCustomValidity('You can\'t use your own promo code.');
                this.Opts?.error?.();
                this.Dirty = false;
                return;
            }
            this.$input.setCustomValidity('');
            this.Opts?.success?.(p);
            this.Dirty = false;
            return;
        }

        this.$input.setCustomValidity('Please enter a valid promo code.');
        this.Opts?.error?.();
        this.Dirty = false;
    }
}